"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AddressUtil = void 0;
const web3_js_1 = require("@solana/web3.js");
class AddressUtil {
  static toPubKey(address) {
    return address instanceof web3_js_1.PublicKey ? address : new web3_js_1.PublicKey(address);
  }
  static toPubKeys(addresses) {
    return addresses.map(address => AddressUtil.toPubKey(address));
  }
  static toString(address) {
    if (typeof address === "string") {
      return address;
    }
    return AddressUtil.toPubKey(address).toBase58();
  }
  static toStrings(addresses) {
    return addresses.map(address => AddressUtil.toString(address));
  }
  static findProgramAddress(seeds, programId) {
    const [publicKey, bump] = web3_js_1.PublicKey.findProgramAddressSync(seeds, programId);
    return {
      publicKey,
      bump
    };
  }
}
exports.AddressUtil = AddressUtil;
//# sourceMappingURL=address-util.js.map